module.exports = __webpack_public_path__ + "VIPC7.png?c2c020ba2341e082ea0f45d9d5ec2355";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/colours/cycling/VIPC7.png
// module id = 70
// module chunks = 0